var exports = {
  "M": "xe7b6e3d6--5db3a5--page",
};

module.exports = exports;
